<div class="row">
  <div class="col-6">
    <app-date-picker [id]="idPrefix + 'Date'"
                     [disabled]="disabled"
                     [content]="date"
                     (contentChange)="onDateChange($event)"></app-date-picker>
  </div>
  <div class="col-6">
    <input type="time" step="60"
           class="form-control"
           [id]="idPrefix + 'Time'"
           [name]="idPrefix + 'Time'"
           [disabled]="disabled"
           [ngModel]="time"
           (ngModelChange)="onTimeChange($event)">
    <small class="form-text text-muted" *ngIf="timeZone">
      Times are in {{ getTimeZoneDisplayName(timeZone) }}.
    </small>
  </div>
</div>
